import { Button, MenuItem, Select, styled } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { FormikProps } from "formik";
import type { PredefinedLEZOption } from "src/types";

interface Props<T> {
  options: PredefinedLEZOption[];
  readOnly: boolean;
  selectedOption: string;
  onSelect: (option: string) => void;
  loadedOption: string;
  onLoad: (option: string) => void;
  isLoading: boolean;
  formikRef: FormikProps<T> | null;
  isFormDirty: boolean;
}

export function FleetConfigSelection<T>(props: Props<T>) {
  const {
    options,
    readOnly,
    selectedOption,
    onSelect,
    loadedOption,
    onLoad,
    isLoading,
  } = props;
  const { t } = useTranslation();

  function handleLoad() {
    onLoad(selectedOption);
  }

  return (
    <Styles className="predefined-fleet-controls">
      <Select
        disabled={readOnly || isLoading}
        displayEmpty
        size="small"
        placeholder={t("label.selectPredefinedFleet")}
        onChange={(e) => onSelect(e.target.value)}
        value={selectedOption}
      >
        <MenuItem disabled value="">
          <em>{t("label.selectPredefinedFleet")}</em>
        </MenuItem>
        {options.map((l) => (
          <MenuItem key={l.nameKey} value={l.nameKey}>
            {l.nameTranslation}
          </MenuItem>
        ))}
      </Select>
      <Button
        disabled={readOnly || selectedOption === loadedOption}
        onClick={handleLoad}
        variant="contained"
        className="load-button"
      >
        {t("label.load")}
      </Button>
    </Styles>
  );
}

const Styles = styled("div")`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  .MuiInputBase-root {
	margin-bottom: 0;
	flex-grow: 1;
  }
  .load-button {
    margin-left: 10px;
  }
  `;
